import { useState } from 'react';
import Modal from './Modal';
import useUser from '../hooks/useUser';
import { useModal } from "../contexts";
import { useTranslation } from 'react-i18next';
import { postData } from '../backend';

interface Props {
  oauthUrl: string;
  onClose?: () => void;
}

function OAuthModalHubspot(props: Props) {
  const { closeModal } = useModal();
  const { refreshUser } = useUser();
  const { t } = useTranslation();

  const [isLoadingAppObjects, setIsLoadingAppObjects] = useState(false);

  async function handleInstallAppObjects() {
    setIsLoadingAppObjects(true);

    try {
      const { url } = await postData("/hubspot/install-app-objects/");
      window.open(url, "_blank");
      window.addEventListener("focus", getCurrentUserOnFocus);
    } catch (error) {
      console.error(error);
    }

    setIsLoadingAppObjects(false);
  }

  function handleInstallIntegration() {
    window.open(props.oauthUrl, "_blank");
    window.addEventListener("focus", getCurrentUserOnFocus);
  }

  async function getCurrentUserOnFocus() {
    window.removeEventListener("focus", getCurrentUserOnFocus);

    refreshUser();
    closeModal(props.onClose);
  }

  return (
    <Modal
      title={t("Connect HubSpot to Portant")}
      subtitle={t("Portant requires access to deals, contacts and companies within your HubSpot account.")}
      className="items-center justify-center"
    >
      <div className="flex items-center gap-4 mt-8 w-full">
        <div className="flex flex-col">
          <span className="font-semibold text-sm">{t("Enable document app objects")}</span>
          <span className="text-gray-400 text-xs">{t("Store generated documents as Portant Document objects in HubSpot. This requires additional HubSpot permissions.")}</span>
        </div>
        <button className="btn btn-white text-sm py-1 px-2 ml-auto flex-shrink-0" disabled={isLoadingAppObjects} onClick={handleInstallAppObjects}>{t("Connect")}</button>
      </div>
      <div className="bg-blue text-white font-semibold py-2 px-4 rounded cursor-pointer my-8" onClick={handleInstallIntegration}>
        {t("Connect HubSpot to Portant")}
      </div>
    </Modal>
  );
}

export default OAuthModalHubspot;
